function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreederIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 95.7",
    style: {
      enableBackground: "new 0 0 77 95.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3FAF66"
    },
    d: "M66,17.5C62.5,12.2,58.4,8,53.9,5C49,1.7,43.8,0,38.5,0C33.2,0,28,1.7,23.1,5 c-4.5,3-8.6,7.2-12.1,12.6C4,28,0,41.3,0,54.1c0,12.6,3.9,23.2,11.3,30.7c6.9,7,16.6,10.9,27.2,10.9c10.7,0,20.3-3.9,27.2-10.9 C73.1,77.3,77,66.7,77,54.1C77,41.3,73,28,66,17.5z M62.2,81.3c-6,6.1-14.4,9.4-23.7,9.4c-9.3,0-17.8-3.3-23.7-9.4 c-6.4-6.6-9.9-16-9.9-27.2c0-11.8,3.7-24.2,10.1-33.8C21.7,10.4,30,4.9,38.5,4.9c8.5,0,16.8,5.4,23.4,15.3 c6.4,9.7,10.1,22,10.1,33.8C72.1,65.3,68.7,74.8,62.2,81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3FAF66"
    },
    d: "M38.5,8.3c-7.3,0-14.8,5-20.6,13.8c-0.8,1.1-0.4,2.7,0.7,3.4c0.4,0.3,0.9,0.4,1.4,0.4 c0.8,0,1.6-0.4,2.1-1.1c4.9-7.4,11-11.6,16.5-11.6c1.4,0,2.5-1.1,2.5-2.5S39.9,8.3,38.5,8.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreederIcon);
export default __webpack_public_path__ + "static/media/breeder-icon.4b875122b62443c7f0c571a4049efd1d.svg";
export { ForwardRef as ReactComponent };